import React, { Dispatch } from "react";
import { Editor as IEditor} from "tinymce";

export const GIF_VISIBLE_OPTION = 'gif_visible';

export const INSERTED_GIF_REGEX = /<img id="(inserted-tenor-gif|inserted-gif)"/g;

export const INSERTED_IMAGE_REGEX = /<img id="inserted-image"/g;

export const getInsertedGifs = (content: string): RegExpMatchArray | null =>
    content.match(INSERTED_GIF_REGEX);

/**
 * The length a comment editor reports: plaintext characters plus one per inserted
 * gif/image. Shared by the character counter and the max-length cap so the two
 * cannot disagree about whether a comment is over the limit.
 */
export const getEditorLength = (editor: IEditor): number => {
    const content = editor.getContent();

    return editor.getContent({ format: 'text' }).length +
        ((getInsertedGifs(content) || content.match(INSERTED_IMAGE_REGEX)) || []).length;
};

export const handleTinyText = (setText: Dispatch<string>, setPlaintext: Dispatch<string>, setCount: Dispatch<number>, editor: IEditor) => {
    setText(editor.getContent())
    setPlaintext(editor.getContent({ format: 'text' }))

    setCount(getEditorLength(editor));
};

export const addGif = (result: any, setPlaintext: Dispatch<string>, setGifsVisible: Dispatch<boolean>, editorRef: React.MutableRefObject<IEditor | null>, gifRef: any) => {
    if (!editorRef.current) return;

    const url = result.images.fixed_width.url;
    const altText = (result.alt_text || result.title || 'GIF').replace(/"/g, '&quot;');
    editorRef.current.insertContent(`<img id="inserted-gif" style="max-width: 200px; max-height: 150px; display: inline-block" src="${url}" alt="${altText}"/>`);
    if (editorRef.current.getContent({ format: 'text' }).trim().length === 0) {
        setPlaintext("📷 GIF");
    }

    gifRef.current.setActive(false)
    editorRef.current.options.set(GIF_VISIBLE_OPTION, false);
    setGifsVisible(false);
};